import { choose } from '../../utils/platform';
import EventFormDesktop from './EventForm.desktop';
import EventFormMobile from './EventForm.mobile';

// Platform chooser: the APK renders the mobile variant, any browser the desktop one.
// Both take the same props; all logic lives in the owning page's hook.
export default choose(EventFormDesktop, EventFormMobile);
